// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2BxWj","rootCenter":"LoadMoreObserver_rootCenter__hbeaW","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__19Kw7"};